import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  useDispatch,
  connect,
} from "../../../atoms/DependencyHelper";
import PersonalDetailsForm from "../../../atoms/newLineForms/creditCheckForms/personalDetailsForm/PersonalDetailsForm";
import PersonalDetailsInfo from "../../../atoms/newLineForms/creditCheckDetails/personalDetailsInfo/PersonalDetailsInfo";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import {
  convertInToObject,
  charRegExp,
  charRegExpForName,
  dateRegex,
  imagePrefix,
  getAge,
  addAutoSlash,
  capitalizeFirstLetter,
  nameRegex,
} from "../../../../utils/helperServices";
import { SET_CREDIT_CHECK_PERSONAL_DATA } from "../../../../Redux/actionTypes/index";
import { MALE, FEMALE, MR, MRS, MISS } from "../../../../config/constants";
import errorMessages from "../../../../config/errorMessages";
import Image from "../../../atoms/image/image";
import formStyles from "../CheckoutCreditCheck.module.scss";
import * as Analytics from "../../../../services/analyticsUtag";
const analyticsTags = [
  "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type",
];
/**
 * Personal Details component holds the logic of personal detail form validation logic,
 * handling all the API calls and analytics
 */
const PersonalDetails = ({
  customerStatus,
  personalDetailsData,
  loadLookupData,
  authDetailsData,
  onFormSubmit,
  profileData,
  doCreditCheckDisable,
}) => {
  const [analytics, setAnalytics] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [displayEditMode, setDisplayEditMode] = useState(
    personalDetailsData ? false : true
  );
  const [titles, setTitles] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [gender, setGender] = useState(["Male", "Female"]);

  const cloneOfErrorMessages = JSON.parse(
    JSON.stringify(errorMessages.creditCheckout.errors.personal)
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (personalDetailsData) {
      fieldValues.personalDetails.title = personalDetailsData.title;
      fieldValues.personalDetails.initials = personalDetailsData.initials;
      fieldValues.personalDetails.firstName = personalDetailsData.firstName;
      fieldValues.personalDetails.surName = personalDetailsData.surName;
      fieldValues.personalDetails.gender = personalDetailsData.gender;
      fieldValues.personalDetails.dob = personalDetailsData.dob;
      fieldValues.personalDetails.maritalStatus =
        personalDetailsData.maritalStatus;

      errorStatus.personalDetails = checkFormError("personalDetails");

      if (errorStatus.personalDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    } else if (profileData) {
      fieldValues.personalDetails.firstName = profileData?.firstname
        ? profileData.firstname
        : "";
      if (!charRegExpForName.test(profileData?.firstname)) {
        fieldErrors["personalDetails"].firstName = true;
        fieldErrorsMessage["personalDetails"].firstName =
          errorMessages.creditCheckout.personalDetails.firstName.onlyValid;
        inlineAnalytics(
          errorMessages.creditCheckout.personalDetails.firstName.onlyValid
        );
      } else if (profileData?.firstname.length < 3) {
        fieldErrors["personalDetails"].firstName = true;
        fieldErrorsMessage["personalDetails"].firstName =
          errorMessages.creditCheckout.personalDetails.firstName.minCharacters;
        inlineAnalytics(
          errorMessages.creditCheckout.personalDetails.firstName.minCharacters
        );
      } else {
        fieldErrors["personalDetails"].firstName = false;
      }

      setState({
        ...state,
        fieldErrors,
        fieldValues,
        fieldErrorsMessage,
      });
    }
  }, [personalDetailsData, profileData]);

  const [state, setState] = useState({
    validationsOn: {
      personalDetails: true,
    },
    errorStatus: {
      personalDetails: true,
    },
    validations: {
      personalDetails: {
        title: true,
        initials: true,
        firstName: true,
        surName: true,
        gender: true,
        dob: true,
        maritalStatus: true,
      },
    },
    fieldErrors: {
      personalDetails: {
        title: false,
        initials: false,
        firstName: false,
        surName: false,
        gender: false,
        dob: false,
        maritalStatus: false,
      },
      fail: false,
    },
    fieldValues: {
      personalDetails: {
        title: "",
        initials: "",
        firstName: "",
        surName: "",
        gender: "",
        dob: "",
        maritalStatus: "",
      },
    },
    fieldErrorsMessage: cloneOfErrorMessages,
  });

  const {
    validationsOn,
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    fieldErrorsMessage,
  } = state;

  useEffect(() => {
    setTitles(capitalizeTitles(loadLookupData?.TITLES));
    setMaritalStatus(loadLookupData?.MARITAL_STATUSES);
  }, []);

  /**
   * This function is used to get capitalized titles from the loadlookup api
   *
   * @call onLoad event
   */
  const capitalizeTitles = (strValues) => {
    let updatedTitles = [];
    if (strValues) {
      strValues.map((item) => {
        if (capitalizeFirstLetter(item) === "Dr") {
          updatedTitles.push("Dr.");
        } else {
          updatedTitles.push(capitalizeFirstLetter(item));
        }
      });
    }
    return updatedTitles;
  };

  /** This function is used to get birthdate and gender from the SAID number
   * @call onLoad event
   */
  useEffect(() => {
    if (authDetailsData?.idType === "SAID") {
      const idNumber = authDetailsData?.idNumber;
      let bday = idNumber.toString().slice(0, 6),
        gender = idNumber.toString().slice(6, 10);

      let d = new Date(),
        y = d.getFullYear();
      let lasty = parseInt(y.toString().slice(0, 2));
      let n = d.getFullYear() - 100,
        l = parseInt(n.toString().substr(-2));
      let u = parseInt(100 - l);

      let yy = bday.toString().slice(0, 2),
        mm = bday.toString().slice(2, 4),
        dd = bday.toString().slice(4, 6);

      fieldValues["personalDetails"]["gender"] = getGenderFromSAID(gender);
      fieldValues["personalDetails"]["dob"] = getBirthYearFromSAID(
        yy,
        l,
        u,
        lasty,
        mm,
        dd
      );

      setState({
        ...state,
        fieldValues,
      });
    }
  }, []);

  /**
   * This function is used to get birthdate from entered SAID
   *
   * @usage Set the user's birthdate
   * @call onLoad event
   */
  const getBirthYearFromSAID = (value, l, u, lasty, mm, dd) => {
    let bdate = "";
    let f_lower = Math.min(0, l),
      f_upper = Math.max(0, l),
      m_lower = Math.min(l + 1, u),
      m_upper = Math.max(l + 1, 100);

    if (value >= f_lower && value <= f_upper) {
      bdate =
        dd +
        " / " +
        mm +
        " / " +
        lasty.toString().concat(("0" + value).slice(-2));
    }

    if (value >= m_lower && value <= m_upper) {
      bdate =
        dd +
        " / " +
        mm +
        " / " +
        (lasty - 1).toString().concat(("0" + value).slice(-2));
    }

    return bdate;
  };

  /**
   * This function is used to get gender from entered SAID
   *
   * @usage Set the user's gender
   * @call onLoad event
   */
  const getGenderFromSAID = (value) => {
    let gender = "";
    let f_lower = Math.min(0, 4999),
      f_upper = Math.max(0, 4999),
      m_lower = Math.min(5000, 9999),
      m_upper = Math.max(5000, 9999);

    if (value >= f_lower && value <= f_upper) {
      gender = "female";
    }

    if (value >= m_lower && value <= m_upper) {
      gender = "male";
    }

    return gender;
  };

  /**
   * Form input field change event handler
   *
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    event.persist();

    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: personal details`,
      });
      setAnalytics(true);
    }
    await updateFieldValues(event, val, form);
  };

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    event.persist();
    await fieldValidationCheck(event, val, form);

    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
    });

    if (fieldErrors.fail) {
      setSubmitDisabled(true);
      let name = event.target.name;
      let errMsg = fieldErrorsMessage[form][name];
      inlineAnalytics(errMsg);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */
  const handleReset = async (name, form) => {
    switch (name) {
      case "title":
        fieldValues[form].title = "";
        break;
      case "maritalStatus":
        fieldValues[form].maritalStatus = "";
        break;
      case "gender":
        if (authDetailsData?.idType !== "SAID") {
          fieldValues[form].gender = "";
        }
        break;
    }
    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      fieldValues,
      errorStatus,
    });

    if (errorStatus[form]) {
      setSubmitDisabled(true);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */
  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (const err of errValues) {
      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */
  const fieldValidationCheck = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    switch (name) {
      case "title":
        if (state.validationsOn[form] && state.validations[form].title) {
          if (value?.length == 0) {
            fieldErrors[form].title = true;
            fieldErrorsMessage[form].title =
              state.fieldErrorsMessage.personalDetails.title;
          } else {
            fieldErrors[form].title = false;
          }
          fieldErrors.fail = fieldErrors[form].title;
        } else {
          fieldErrors[form].title = false;
        }
        break;

      case "initials":
        if (state.validationsOn[form] && state.validations[form].initials) {
          if (value?.length > 0) {
            if (!charRegExp.test(value)) {
              fieldErrors[form].initials = true;
              fieldErrorsMessage[form].initials =
                errorMessages.creditCheckout.personalDetails.initials.onlyValid;
            } else {
              fieldErrors[form].initials = false;
            }
          } else {
            fieldErrors[form].initials = true;
            fieldErrorsMessage[form].initials =
              errorMessages.creditCheckout.errors.personal.personalDetails.initials;
          }
          fieldErrors.fail = fieldErrors[form].initials;
        } else {
          fieldErrors[form].initials = false;
        }
        break;

      case "firstName":
        if (state.validationsOn[form] && state.validations[form].firstName) {
          if (value?.length > 0) {
            if (!nameRegex.test(value)) {
              fieldErrors[form].firstName = true;
              fieldErrorsMessage[form].firstName =
                errorMessages.creditCheckout.personalDetails.firstName.onlyValid;
            } else if (value.length < 3) {
              fieldErrors[form].firstName = true;
              fieldErrorsMessage[form].firstName =
                errorMessages.creditCheckout.personalDetails.firstName.minCharacters;
            } else {
              fieldErrors[form].firstName = false;
            }
          } else {
            fieldErrors[form].firstName = true;
            fieldErrorsMessage[form].firstName =
              errorMessages.creditCheckout.errors.personal.personalDetails.firstName;
          }
          fieldErrors.fail = fieldErrors[form].firstName;
        } else {
          fieldErrors[form].firstName = false;
        }
        break;

      case "surName":
        if (state.validationsOn[form] && state.validations[form].surName) {
          if (value?.length > 0) {
            if (!nameRegex.test(value)) {
              fieldErrors[form].surName = true;
              fieldErrorsMessage[form].surName =
                errorMessages.creditCheckout.personalDetails.surName.onlyValid;
            } else if (value.length <= 2) {
              fieldErrors[form].surName = true;
              fieldErrorsMessage[form].surName =
                errorMessages.creditCheckout.personalDetails.surName.minCharacters;
            } else {
              fieldErrors[form].surName = false;
            }
          } else {
            fieldErrors[form].surName = true;
            fieldErrorsMessage[form].surName =
              errorMessages.creditCheckout.errors.personal.personalDetails.surName;
          }
          fieldErrors.fail = fieldErrors[form].surName;
        } else {
          fieldErrors[form].surName = false;
        }
        break;

      case "gender":
        if (state.validationsOn[form] && state.validations[form].gender) {
          if (fieldValues[form].gender?.length > 0) {
            if (fieldValues[form].gender === MALE) {
              if (
                state.fieldValues[form].title === MRS ||
                state.fieldValues[form].title === MISS
              ) {
                fieldErrors[form].gender = true;
                fieldErrorsMessage[form].gender =
                  errorMessages.creditCheckout.personalDetails.gender.matchValue;
              } else {
                fieldErrors[form].gender = false;
              }
            } else if (fieldValues[form].gender === FEMALE) {
              if (state.fieldValues[form].title === MR) {
                fieldErrors[form].gender = true;
                fieldErrorsMessage[form].gender =
                  errorMessages.creditCheckout.personalDetails.gender.matchValue;
              } else {
                fieldErrors[form].gender = false;
              }
            }
          } else {
            fieldErrors[form].gender = true;
            fieldErrorsMessage[form].gender =
              errorMessages.creditCheckout.errors.personal.personalDetails.gender;
          }
          fieldErrors.fail = fieldErrors[form].gender;
        } else {
          fieldErrors[form].gender = false;
        }
        break;

      case "maritalStatus":
        if (
          state.validationsOn[form] &&
          state.validations[form].maritalStatus
        ) {
          if (value?.length == 0) {
            fieldErrors[form].maritalStatus = true;
            fieldErrorsMessage[form].maritalStatus =
              state.fieldErrorsMessage.personalDetails.maritalStatus;
          } else {
            fieldErrors[form].maritalStatus = false;
          }
          fieldErrors.fail = fieldErrors[form].maritalStatus;
        } else {
          fieldErrors[form].maritalStatus = false;
        }
        break;

      case "dob":
        if (state.validationsOn[form] && state.validations[form].dob) {
          if (value?.length > 0) {
            if (!dateRegex.test(value)) {
              fieldErrors[form].dob = true;
              fieldErrorsMessage[form].dob =
                errorMessages.creditCheckout.personalDetails.dob.onlyValid;
            } else {
              if (getAge(value) < 18) {
                fieldErrors[form].dob = true;
                fieldErrorsMessage[form].dob =
                  errorMessages.creditCheckout.personalDetails.dob.minAge;
              } else {
                fieldErrors[form].dob = false;
              }
            }
          } else {
            fieldErrors[form].dob = true;
            fieldErrorsMessage[form].dob =
              errorMessages.creditCheckout.errors.personal.personalDetails.dob;
          }
          fieldErrors.fail = fieldErrors[form].dob;
        } else {
          fieldErrors[form].dob = false;
        }
        break;
    }

    if (displayEditMode) {
      if (name === "title" || name === "gender" || name === "maritalStatus") {
        //capture analytics user selects "title, gender, maritalStatus"
        selectionAnalytics(name, value);
      }
    }

    setState({
      ...state,
      fieldErrors,
      fieldValues,
      fieldErrorsMessage,
    });
  };

  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    fieldValues[form][name] = value;
    if (name === "title") {
      if (authDetailsData?.idType !== "SAID") {
        fieldErrors[form].gender = false;
        if (value === MR) {
          fieldValues[form].gender = MALE;
        } else if (value === MRS || value === MISS) {
          fieldValues[form].gender = FEMALE;
        } else {
          fieldValues[form].gender = "";
        }
      }
      fieldValues[form][name] = value;
    } else if (name == "dob") {
      //call function to add auto slash in date field
      fieldValues[form][name] = addAutoSlash(value);
    } else if (name == "gender") {
      if (state.validationsOn[form] && state.validations[form].gender) {
        if (value.length > 0) {
          if (value === MALE) {
            if (
              state.fieldValues[form].title === MRS ||
              state.fieldValues[form].title === MISS
            ) {
              fieldErrors[form].gender = true;
              fieldErrorsMessage[form].gender =
                errorMessages.creditCheckout.personalDetails.gender.matchValue;
            } else {
              fieldErrors[form].gender = false;
            }
          } else if (value === FEMALE) {
            if (state.fieldValues[form].title === MR) {
              fieldErrors[form].gender = true;
              fieldErrorsMessage[form].gender =
                errorMessages.creditCheckout.personalDetails.gender.matchValue;
            } else {
              fieldErrors[form].gender = false;
            }
          }
        } else {
          fieldErrors[form].gender = true;
          fieldErrorsMessage[form].gender =
            errorMessages.creditCheckout.errors.personal.personalDetails.gender;
        }
        fieldErrors.fail = fieldErrors[form].gender;
      } else {
        fieldErrors[form].gender = false;
      }
    } else {
      fieldValues[form][name] = value;
    }
    setState({
      ...state,
      fieldValues,
    });
  };

  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */
  const inlineAnalytics = (message) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_form_event: "error",
      page_errors: message,
      page_form_name: `checkout: credit check: ${customerStatus}: personal details`,
      page_error_type: "form",
    });
  };

  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change(title, gender, maritalStatus)
   */
  const selectionAnalytics = (selectionType, value) => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: edit ${selectionType} details`,
      filter_query: value,
    });
  };

  /**
   * Set the on page submit
   *
   * @call on next button click
   */
  const setAnalyticsOnNextButton = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: personal details: next`,
    });
  };

  /**
   * Set the on page edit
   *
   * @call on edit event
   */
  const setAnalyticsOnPageEdit = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: edit personal details`,
    });
  };

  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */
  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["personalDetails"]) {
      submitForm();
    }
  };

  /**
   *
   * @usage submit the form with request payload
   */
  const submitForm = async () => {
    onFormSubmit(true);
    setDisplayEditMode(false);
    doCreditCheckDisable("personalDetails", false);
    dispatch({
      type: SET_CREDIT_CHECK_PERSONAL_DATA,
      payload: { ...state.fieldValues["personalDetails"] },
    });

    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "success",
      page_form_name: `checkout: credit check: ${customerStatus}: personal details`,
    });
  };

  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */
  const clickOnEditButton = () => {
    setDisplayEditMode(true);
    doCreditCheckDisable("personalDetails", true);
    setAnalyticsOnPageEdit();
  };

  return (
    <>
      <CustomContainer
        className={`${formStyles["container"]}`}
        id="personal-details"
      >
        <CustomContainer className={formStyles["form-heading"]}>
          {displayEditMode ? (
            <Image
              img_path={`${imagePrefix}/assets/images/icon-personal.svg`}
              img_alt="section"
              className={formStyles["section-icon"]}
            />
          ) : (
            <Image
              img_path={`${imagePrefix}/assets/images/success-circle_small.svg`}
              img_alt="success"
              className={formStyles["section-success-icon"]}
            />
          )}
          Personal details
          {displayEditMode ? (
            <CustomContainer className={formStyles["section-numbers"]}>
              Section 1 of 7
            </CustomContainer>
          ) : (
            <CustomContainer className={formStyles["section-numbers"]}>
              <a onClick={() => clickOnEditButton()}>
                <Image
                  img_path={`${imagePrefix}/assets/images/blog.svg`}
                  img_alt="edit"
                />
                <span>Edit details</span>
              </a>
            </CustomContainer>
          )}
        </CustomContainer>
        <hr></hr>
        {!displayEditMode ? (
          <PersonalDetailsInfo data={personalDetailsData} />
        ) : (
          <Form
            noValidate
            id="checkout-credit-check-personal-form"
            onSubmit={handleSubmit}
          >
            <PersonalDetailsForm
              formName={"personalDetails"}
              fieldValues={state.fieldValues["personalDetails"]}
              fieldErrors={state.fieldErrors["personalDetails"]}
              fieldErrorsMessage={state.fieldErrorsMessage["personalDetails"]}
              onChangeHandler={handleChange}
              onBlurHandler={handleBlur}
              onResetHandler={handleReset}
              titles={convertInToObject(titles)}
              maritalStatusList={convertInToObject(maritalStatus)}
              genders={convertInToObject(gender)}
              idType={authDetailsData?.idType}
              data={personalDetailsData}
            />
            <CustomContainer className={formStyles["button-wrapper"]}>
              <CTAButton
                type="submit"
                variant="solid grey"
                disabled={submitDisabled}
                className={formStyles["button"]}
                id="checkout-credit-check-personal-form-submit"
              >
                Next
              </CTAButton>
            </CustomContainer>
          </Form>
        )}
      </CustomContainer>
    </>
  );
};

PersonalDetails.propTypes = {
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    personalDetailsData: state.creditCheckDetails.personalDetails,
    loadLookupData: state.checkoutDetails.lookupDetails,
    authDetailsData: state.checkoutDetails.authDetails,
  };
};

export default connect(mapStateToProps)(PersonalDetails);
